import React from "react";

import type { JSX } from "react";

interface TimeslotMediaIconProps {
  className?: string;
  height?: number;
  width?: number;
}

function TimeslotMediaIcon({
  className,
  height = 40,
  width = 40,
}: TimeslotMediaIconProps): JSX.Element {
  return (
    <svg
      className={className}
      fill="none"
      height={height}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.75 4C4.75 2.20508 6.20508 0.75 8 0.75H24C24.1212 0.75 24.2375 0.798159 24.3232 0.883885L35.1161 11.6768C35.2018 11.7625 35.25 11.8788 35.25 12V36C35.25 37.7949 33.7949 39.25 32 39.25H8C6.20507 39.25 4.75 37.7949 4.75 36V4Z"
        fill="var(--card)"
        stroke="var(--border-strong)"
        strokeWidth="1.5"
      />
      <path
        d="M24 0.5V8C24 10.2091 25.7909 12 28 12H35.5"
        stroke="var(--border-strong)"
        strokeWidth="1.5"
      />
      <path
        d="M15 21.5001L10 24.0001L19.6422 28.8212C19.7734 28.8868 19.839 28.9196 19.9078 28.9325C19.9687 28.9439 20.0313 28.9439 20.0922 28.9325C20.161 28.9196 20.2266 28.8868 20.3578 28.8212L30 24.0001L25 21.5001M15 26.5001L10 29.0001L19.6422 33.8212C19.7734 33.8868 19.839 33.9196 19.9078 33.9325C19.9687 33.9439 20.0313 33.9439 20.0922 33.9325C20.161 33.9196 20.2266 33.8868 20.3578 33.8212L30 29.0001L25 26.5001M10 19.0001L19.6422 14.179C19.7734 14.1134 19.839 14.0806 19.9078 14.0677C19.9687 14.0562 20.0313 14.0562 20.0922 14.0677C20.161 14.0806 20.2266 14.1134 20.3578 14.179L30 19.0001L20.3578 23.8212C20.2266 23.8868 20.161 23.9196 20.0922 23.9325C20.0313 23.9439 19.9687 23.9439 19.9078 23.9325C19.839 23.9196 19.7734 23.8868 19.6422 23.8212L10 19.0001Z"
        stroke="#BA24D5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}
export default TimeslotMediaIcon;
